import { AxiosResponse } from "axios";
import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import {
  setPrivacyPolicyActionStart,
  setPrivacyPolicyErrorMessage,
} from "../../constants/reducers/privacy-policy.reducer";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { store } from "../../store";
import { createCall } from "../base";

export const publishPrivacyPolicy = async (id: number) => {
  store.dispatch(setPrivacyPolicyActionStart(true));

  const request = await createCall(
    `cms/privacy-policies/publish/${id}`,
    BASE_METHODS.PATCH,
    "application/json",
    "1.0.0",
  );

  try {
    const response = request as AxiosResponse;
    store.dispatch(setPrivacyPolicyActionStart(false));
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponseData: CustomErrorType = responseError.response?.data;
    if (errorResponseData) {
      let errorMessage = "";
      switch (errorResponseData.code) {
        case 2001:
          errorMessage = TextEnum.PRIVACY_POLICY_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setPrivacyPolicyErrorMessage(errorMessage));
      return null;
    }
    store.dispatch(setPrivacyPolicyActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
